import React, { useRef, useEffect, useState } from "react";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { TextField, InputAdornment, IconButton, Box, Grid, MenuItem } from "@mui/material";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const timeRangeOptions = [
    {
        key: "1",
        label: "Last 7 Days"
    },
    {
        key: "2",
        label: "Last 30 Days"
    },
    {
        key: "3",
        label: 'Custom'
    }
]
const DateRangePicker = ({ onChange }) => {
    const [selectedRange, setSelectedRange] = useState("")
    const inputWrapperRef = useRef(null);
    const flatpickrInstance = useRef(null);

    useEffect(() => {
        const input = inputWrapperRef.current.querySelector("input");
        flatpickrInstance.current = flatpickr(input, {
            mode: "range",
            dateFormat: "m/d/y",
            rangeSeparator: " - ", // ✅ Custom separator,
            locale: {
                rangeSeparator: " - " // ✅ Locale override (important!)
            },
            onClose: (selectedDates, dateStr) => {
                if (onChange) {
                    setSelectedRange(dateStr)
                    onChange({ target: { selectedDates, dateStr, name: "processedDateRange" } });
                }
            },
        });

        return () => {
            flatpickrInstance.current.destroy();
        };
    }, [onChange]);

    const openCalendar = () => {
        if (flatpickrInstance.current) {
            flatpickrInstance.current.open();
        }
    };

    const handleSelectChange = (e) => {
        const {value} = e.target;
        if(value === "1"){
            const date = new Date();
            const last7Days = new Date(date.setDate(date.getDate() - 7));
            const today = new Date();
            const dateStr = `${last7Days?.toLocaleDateString()} - ${today?.toLocaleDateString()}`;
            onChange({ target: { selectedDates: [last7Days, today], dateStr, name : "processedDateRange" } }); 
            setSelectedRange(dateStr) 
        } else if(value === "2"){
            const date = new Date();
            const last30Days = new Date(date.setDate(date.getDate() - 30));
            const today = new Date();
            const dateStr = `${last30Days?.toLocaleDateString()} - ${today?.toLocaleDateString()}`;
            onChange({ target: { selectedDates: [last30Days, today], dateStr, name : "processedDateRange" } }); 
            setSelectedRange(dateStr)
        } else {
            setSelectedRange("")
            onChange({ target: { selectedDates: "", dateStr: "", name : "processedDateRange" } }); 
        }
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <label htmlFor="custom-input" style={{ fontWeight: 500 }}>
                {"Processed Date Range"}
            </label>
            <Grid container flexDirection={'row'} spacing={1}>
                <Grid item size={5}>
                    <TextField
                        id="time-range"
                        select
                        defaultValue={3}
                        sx={{width: '100%'}}
                        size="small"
                        name="timeRange"
                        onChange={(e) => {handleSelectChange(e)}}
                    >
                        {timeRangeOptions.map((option) => (
                            <MenuItem key={option.key} value={option.key}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item size={7}>
                    <div ref={inputWrapperRef} style={{ width: "100%", display: 'flex' }}>
                        <TextField
                            //   inputRef={inputRef}
                            placeholder="Select Date Range"
                            name="processedDateRange"
                            fullWidth
                            variant="outlined"
                            size="small"
                            value={selectedRange}
                            slotProps={{
                                input: {
                                    readOnly: true, // Prevent manual typing
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={openCalendar}>
                                                <CalendarMonthIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }
                            }}
                        />
                    </div>
                </Grid>
            </Grid>
        </Box>

    );
};

export default DateRangePicker;
